import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

interface TableTotalProps {
	total: number;
}

const TableTotal: FunctionComponent<TableTotalProps> = ({ total }) => {
	const { t } = useTranslation();

	return (
		<div style={{ color: '#555' }}>
			{t('COMMON.TOTAL')}: <span className="fw-bold"> {total} </span> {t('COMMON.RECORDS')}
		</div>
	);
};

export default TableTotal;
